var pic1 = require('../../assets/images/facility/lab/pic1.jpg');
var pic2 = require('../../assets/images/facility/lab/pic2.jpg');
var pic3 = require('../../assets/images/facility/lab/pic3.jpg');
var pic4 = require('../../assets/images/facility/lab/pic4.jpg');
var pic5 = require('../../assets/images/facility/lab/pic2.jpg');
const DataGalleryFacilityLab = [
 {    
	id: 1,
	title:"Lab",
    image: pic1,	    
	alt  :"lab",
  },
  {    
	id: 2,
	title:"lab",
    image: pic2,	    
	alt: "lab",
  },
  {    
	id: 3,
	title:"lab",
    image: pic3,	    
	alt: "lab",
  },
  {    
	id: 4,
	title:"lab",
    image: pic4,	    
	alt: "lab",
  },
  {    
	id: 5,
	title:"lab",
    image: pic5,	    
	alt: "lab",
  },
];
export default DataGalleryFacilityLab;